export enum ProjectStatus {
    draft = 1,
    active = 2,
    cancelled = 3,
    completed = 4
}
